import { checkCustomerSuspended } from "../../customer/index.js";
import { getSharedPaymentProperty, PAYMENT_PROPERTY, PAYMENT_PROVIDERS, } from "../../payment/index.js";
import { CONTRACT_STATUS } from "../constants.js";
export async function resolveContractStatus({ isActive, customerIdentifier, client, paymentCustom, }) {
    if (!isActive)
        return CONTRACT_STATUS.ENDED;
    const isSuspended = customerIdentifier
        ? await checkCustomerSuspended({ identifier: customerIdentifier }, client)
        : false;
    const isInvoice = getSharedPaymentProperty(paymentCustom, PAYMENT_PROPERTY.SHARED.IDENTIFIER) === PAYMENT_PROVIDERS.INVOICE;
    if (isSuspended && isInvoice) {
        return CONTRACT_STATUS.PAUSED;
    }
    return CONTRACT_STATUS.ACTIVE;
}
